import { render, staticRenderFns } from "./invite-schedule.vue?vue&type=template&id=2ed1ba7a&scoped=true&"
import script from "./invite-schedule.vue?vue&type=script&lang=js&"
export * from "./invite-schedule.vue?vue&type=script&lang=js&"
import style0 from "./invite-schedule.vue?vue&type=style&index=0&id=2ed1ba7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed1ba7a",
  null
  
)

export default component.exports